import _concat from "lodash/concat";
import verifyCode from "./verifyCode";
import response from "./response";

export default {
  path: "/verify",
  component: () => import("@/layouts/VerificationLayout"),
  children: _concat(verifyCode, response)
};
